import { path, allowedRoles } from "../common/constant";
import {
  EditBlog,
  CreateBlog,
  ManageBlogs,
  ManageProjects,
  CreateProject,
  EditProject,
} from "../../pages";

export const PrivateRoutes = [
  {
    path: `${path.private.MANAGEBLOG}`,
    exact: true,
    component: <ManageBlogs />,
    main: () => <ManageBlogs />,
    role: [allowedRoles[0]],
  },
  {
    path: `${path.private.CREATEBLOG}`,
    exact: true,
    component: <CreateBlog />,
    main: () => <CreateBlog />,
    role: [allowedRoles[0]],
  },
  {
    path: `${path.private.EDITBLOG}`,
    exact: true,
    component: <EditBlog />,
    main: () => <EditBlog />,
    role: [allowedRoles[0]],
  },

  {
    path: `${path.private.MANAGEPROJECTS}`,
    exact: true,
    component: <ManageProjects />,
    main: () => <ManageProjects />,
    role: [allowedRoles[0]],
  },
  {
    path: `${path.private.CREATEPROJECT}`,
    exact: true,
    component: <CreateProject />,
    main: () => <CreateProject />,
    role: [allowedRoles[0]],
  },
  {
    path: `${path.private.EDITPROJECT}`,
    exact: true,
    component: <EditProject />,
    main: () => <EditProject />,
    role: [allowedRoles[0]],
  },
];
